import { listFromId } from 'utils/arrays';

export function getPoints(route) {
  const legs = listFromId(route, 'legs').map(leg => leg.points);
  let points = legs.shift();
  const waypoints = [];
  legs.forEach(leg => {
    points = points.concat(leg.slice(1));
    waypoints.push(points.length - 1);
  });
  const coordinates = points
    .map(pt => `${pt.lng.toFixed(5)},${pt.lat.toFixed(5)},0`)
    .join(' ');

  return {
    coordinates,
    waypoints: waypoints.toString(),
    lat: points[0].lat.toFixed(6),
    lng: points[0].lng.toFixed(6),
  };
}

function prepareRoute(route) {
  const { distance, meta } = route;
  return {
    ...meta,
    distance: distance / 1000,
    ...getPoints(route),
  };
}

export default prepareRoute;
